import { Injectable } from '@angular/core';
import { TrPlayerSession } from '../models/tr-player-session.model';
import { StorageService } from '../../../services/storage.service';

const sessionStorageKey = 'tr-player:session';

@Injectable()
export class TrPlayerSessionManagerService {

    /**
     * Recupera informações de uma sessão anterior
     */
    public getPreviousSessionInformation(): TrPlayerSession {
        const session = JSON.parse(StorageService.getCookie(sessionStorageKey) || '{}');
        return session ? session as TrPlayerSession : new TrPlayerSession();
    }

    /**
     * Salva informações da sessão do usuário
     * @param session sessão
     */
    public setSessionInformation(session: TrPlayerSession) {
        StorageService.setCookie(sessionStorageKey, JSON.stringify(session));
    }
}
